/* eslint-disable react-hooks/exhaustive-deps */
import { Grid, Theme, Fab, Typography, Box, Button, useMediaQuery, Tooltip } from "@mui/material";
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { CheckBox, CheckBoxOutlineBlank, FilterList } from "@mui/icons-material";
import { useCallback, useEffect, useMemo, useState } from "react";
import { Carrinho } from "src/components/loja/Carrinho";
import { CarrinhoStore } from "src/components/loja/Carrinho/store";
import { Produto } from "src/components/loja/Produto";
import { Filter, LocalStorage, RequestUtil, SUFIXO_FIELD } from "src/framework/commons";
import { EasyDataGrid } from "src/framework/components/base/EasyDataGrid";
import { GridPresenter } from "src/framework/components/base/EasyDataGrid/GridPresenter";
import { EasyDataGridStore } from "src/framework/components/base/EasyDataGrid/store";
import { Filters } from "src/framework/components/base/Filters";
import { FilterDrawer } from "src/framework/components/commons/FilterDrawer";
import { InputComboBoxList, InputText } from "src/framework/components/forms";
import api, { apiNoLoading, IDataResponse, STATUS_CODE } from "src/framework/providers/api";
import { useObservable } from "src/framework/store/storeUtil";
import { avulsos$, estadoId$, getAtributos, getAvulsos, getComponentes, getEstruturas, getSelos, segmento$, tipoVenda$, uploadUrl } from "src/store/global.store";
import { Cidade, ComponenteType, SelectOption, TCategoriasComponentes, TiposEstruturas } from "src/types";
import { ESTADOS, ORDENATION_OPTIONS, TIPO_INVERSOR, NUMERO_FASES_INVERSOR, TENSAO_INVERSOR, TECNOLOGIA_CONTROLADOR_CARGA, INVERSOR_ID, MICROINVERSOR_ID, MODULO_ID, CONTROLADORES_DE_CARGA_ID, ONDA_MODIFICADA_ID, DRIVE_SOLAR_ID, ONDA_SENOIDAL_ID, TENSAO_BATERIA, TIPO_BATERIA, TIPO_INVERSOR_OFFGRID, ORDENATION_AVULSO_OPTIONS} from "./constants";
import "./style.scss";
import { DetalhesProduto } from "src/components/loja/DetalhesProduto";
import { TProduto } from "src/components/loja/Produto/types";
import { Selo } from "src/components/loja/Selo";
import { TCarrinhoAvulso, TCarrinhoItem } from "src/components/loja/Carrinho/types";
import { PermissionUtil } from "src/framework/commons/PermissionUtil";
import theme from "src/theme/light";
import { getUserInfo, permissoes$ } from "src/framework/store/LoginStore";
import { notifierStore } from "src/framework/components/commons/dialogs/Notifier/store";
import { pageTitle$ } from "src/framework/store/AppStore";
import { confirmationDialog } from "src/framework/store";
import { Avulso } from "src/components/loja/Avulso";
import { DetalhesAvulso } from "src/components/loja/DetalhesAvulso";

export interface EstadoEstabelecimento {
    label: string,
    value: string
}

interface ErrorState {
    potencia: ErrorValidate
}
interface ErrorValidate {
    hasError: boolean;
    hintText: string;
}
const INITIAL_ERROR_STATE: ErrorState = {
    potencia: {
        hasError: false,
        hintText: "",
    }
}

const ProdutosDataGridStore = new EasyDataGridStore(api);

export enum FIELDS {
    SEGMENTO = "segmento",
    MODULO_ID = "modulo_id",
    ESTRUTURA_ID = "tipo_estrutura_id",
    ESTADO_ID = "estado_id",
    POTENCIA_INICIAL = "potencia",
    POTENCIA_FINAL = "potencia",
    TIPO_INVERSOR = "tipo_inversor",
    TIPO_INVERSOR_OFF = "tipo_inversor_off",
    INVERSOR_ID = "inversor_id",
    NUMERO_FASES_INVERSOR = "numero_fases",
    TENSAO_INVERSOR = "tensao",
    TECNOLOGIA_CONTROLADOR_CARGA = "tecnologia_controlador",
    CONTROLADOR_ID = "controlador_id",
    TIPO_BATERIA = "tipo_bateria",
    TENSAO_BATERIA = "tensao_bateria",
    INCLUDES = "includes",
    CATEGORIA_COMPONENTES_ID = "categoria_componentes_id",
    NOME = "nome",
}

const FILTERS: { [filterName: string]: Filter } = {
    [`${FIELDS.SEGMENTO}`]: {
        field: FIELDS.SEGMENTO,
        value: "on",
    },
    [`${FIELDS.MODULO_ID}`]: {
        field: FIELDS.MODULO_ID,
        criteria: SUFIXO_FIELD.IN,
        value: "",
    },
    [`${FIELDS.INVERSOR_ID}`]: {
        field: FIELDS.INVERSOR_ID,
        criteria: SUFIXO_FIELD.IN,
        value: "",
    },
    [`${FIELDS.ESTRUTURA_ID}`]: {
        field: FIELDS.ESTRUTURA_ID,
        criteria: SUFIXO_FIELD.IN,  
        value: "",
    },
    [`${FIELDS.POTENCIA_INICIAL}_inicial`]: {
        field: "potencia",
        criteria: SUFIXO_FIELD.MORE_EQUAL,
        value: "",
    },
    [`${FIELDS.POTENCIA_FINAL}_final`]: {
        field: "potencia",
        criteria: SUFIXO_FIELD.LESS_EQUAL,
        value: "",
    },
    [`${FIELDS.TIPO_INVERSOR}`]: {
        field: FIELDS.TIPO_INVERSOR,
        criteria: SUFIXO_FIELD.IN,
        value: "",
    },
    [`${FIELDS.TIPO_INVERSOR_OFF}`]: {
        field: FIELDS.TIPO_INVERSOR_OFF,
        criteria: SUFIXO_FIELD.IN,
        value: "",
    },
    [`${FIELDS.ESTADO_ID}`]: {
        field: FIELDS.ESTADO_ID,
        value: "",
    },
    [`${FIELDS.NUMERO_FASES_INVERSOR}`]: {
        field: FIELDS.NUMERO_FASES_INVERSOR,
        criteria: SUFIXO_FIELD.IN,
        value: "",
    },
    [`${FIELDS.TENSAO_INVERSOR}`]: {
        field: FIELDS.TENSAO_INVERSOR,
        criteria: SUFIXO_FIELD.IN,
        value: "",
    },
    [`${FIELDS.TECNOLOGIA_CONTROLADOR_CARGA}`]: {
        field: FIELDS.TECNOLOGIA_CONTROLADOR_CARGA,
        criteria: SUFIXO_FIELD.IN,
        value: [],
    },
    [`${FIELDS.CONTROLADOR_ID}`]: {
        field: FIELDS.CONTROLADOR_ID,
        criteria: SUFIXO_FIELD.IN,
        value: "",
    },
    [`${FIELDS.TENSAO_BATERIA}`]: {
        field: FIELDS.TENSAO_BATERIA,
        criteria: SUFIXO_FIELD.IN,
        value: "",
    },
    [`${FIELDS.TIPO_BATERIA}`]: {
        field: FIELDS.TIPO_BATERIA,
        criteria: SUFIXO_FIELD.IN,
        value: "",
    },
    [`${FIELDS.INCLUDES}`]: {
        field: FIELDS.INCLUDES,
        value: "",
    },
    [`${FIELDS.CATEGORIA_COMPONENTES_ID}`]: {
        criteria: SUFIXO_FIELD.IN,
        field: FIELDS.CATEGORIA_COMPONENTES_ID,
        value: "",
    },
    [`${FIELDS.NOME}`]: {
        criteria: SUFIXO_FIELD.LIKE,
        field: FIELDS.NOME,
        value: "",
    },
}

const useStyles = makeStyles((_theme: Theme) =>
    createStyles({
        paginationToolbarRoot: {
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center'
        },
        paginationRoot: {
            display: 'flex',
            flexWrap: 'wrap',
        },
        itemImage: {
            width: 151,
            height: 151
        },
        CardProduto: {
            borderBottom: "3px solid " + theme.palette.primary.main,
            padding: theme.spacing(1),
            "tags": {
                marginRight: theme.spacing(1),
            }
        },
        AdvancedFilter: {
            [theme.breakpoints.up('md')]: {
                backgroundColor: 'red',
            },  
        },
        acoes_filtro: {
            display: "flex", 
            justifyContent: "flex-end",
            alignItems: "center",
           
        },
        acoes_button: {
            marginLeft: theme.spacing(1),
        }
    }),
);

const SEGMENTOS = ['on', 'off', 'todos', ''];

const PATH_KITS = {
    create: "/produtos",
    delete: "/produtos",
    list: "/produtos/consultar",
    read: "/produtos/detalhes",
    update: "/produtos",
    cache: "/produtos/cache",
}

const PATH_AVULSO = {
    create: "/estoque/componentes",
    delete: "/estoque/componentes",
    list: "/estoque/componentes/avulso",
    read: "/estoque/componentes/detalhes",
    update: "/estoque/componentes",
    cache: "/estoque/componentes/cache",
}

const ORDER_KITS = {
    order_1: "prioridade", 
    order_2: "created_at", 
    order_3: ""
}

const ORDER_AVULSO = {
    order_1: "created_at", 
    order_2: "", 
    order_3: ""
}

ProdutosDataGridStore.setPaths(PATH_KITS);

ProdutosDataGridStore.setFilters({...FILTERS})

ProdutosDataGridStore.setPerPageList([8, 16, 32, 64])

ProdutosDataGridStore.setPerPage(8);

const Home = () => {
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const categorias = LocalStorage.get("solar.categorias", true) || [];

    pageTitle$.next("");
    const [isLoaded, setIsLoaded] = useState<boolean>(false);
    const [updatedUf, setUpdatedUf] = useState<boolean>(false);
    const [estadoEstabelecimento, setEstadoEstabelecimento] = useState<EstadoEstabelecimento | null>(null);
    const [avisoInicial, setAvisoInicial] = useState<string>('Carregando...');
    
    const classes = useStyles();
    const filters = useObservable(ProdutosDataGridStore.filters) || {};
    const [orders, setOrders] = useState<{order_1: string, order_2: string, order_3: string}>(ORDER_KITS);
    const _segmento = useObservable(segmento$) || "";
    const tipoVenda = useObservable(tipoVenda$) || "";
    const carrinho = useObservable(CarrinhoStore.carrinho);
    const avulsos = useObservable(avulsos$) || [];

    const [potenciaInicial, setPotenciaInicial] = useState("");
    const [potenciaFinal, setPotenciaFinal] = useState("");
    const [openFilterDrawer, setOpenFilterDrawer] = useState<boolean>(false);
    const [alterouTipoVenda, setAlterouTipoVenda] = useState<boolean>(false);
    const [produtoDetalhes, setProdutoDetalhes] = useState<TProduto | null>(null);
    const [avulsoDetalhes, setAvulsoDetalhes] = useState<ComponenteType | null>(null);

    const _totalItens = useObservable(CarrinhoStore.totalItens) || 0;

    const [nomeMinHeight, setNomeMinHeight] = useState<number | undefined>(undefined);
    const [tagsMinHeight, setTagsMinHeight] = useState<number | undefined>(undefined);

    const [errorState, setErrorState] = useState<ErrorState>(INITIAL_ERROR_STATE);

    const [estruturasState, setEstruturasState] = useState<TiposEstruturas[] | null>([]);
    const [componentesState, setComponentesState] = useState<ComponenteType[] | null>([]);
    const [listaModulos, setListaModulos] = useState<SelectOption[]>([]);
    const [listaInversores, setListaInversores] = useState<SelectOption[]>([]);
    const [listaControladorCarga, setListaControladorCarga] = useState<SelectOption[]>([]);
    const [listEstruturas, setListEstruturas] = useState<SelectOption[]>([]);
    
    const vendaAvulso = useMemo(() => {
        return tipoVenda === 'avulso';
    }, [tipoVenda]);

    const validateSegmento = (item: TCarrinhoItem): boolean => {
        const carrinho = CarrinhoStore.getCarrinho()
        const itensNoCarrinho = carrinho?.itens?.map((_item: TCarrinhoItem) => _item?.produto) || [];
        return itensNoCarrinho.some((_item: any) => _item?.segmento !== item?.produto?.segmento);
    }

    const validateTipoVenda = (): boolean => {
        const carrinho = CarrinhoStore.getCarrinho()
        const itensNoCarrinho = (!!carrinho?.itens?.length || !!carrinho?.avulsos?.length);
        return itensNoCarrinho && (carrinho?.venda !== tipoVenda);
    }

    const maskDecimal = useCallback((value: string)=>{
        let _value = value;
        _value = _value.replace(/\D/g, "");
        _value = _value.replace(/(\d)(\d{2})$/, "$1,$2");
        _value = _value.replace(/(?=(\d{3})+(\D))\B/g, ".");

        return _value;
    },[potenciaInicial,potenciaFinal])

    const estadoId = useMemo(() => {
        const estadoSelecioando = ESTADOS?.find((item: any) => filters && item?.value === filters[FIELDS.ESTADO_ID]?.value)?.value || undefined;
        if (estadoSelecioando) estadoId$.next(estadoSelecioando);
        return estadoSelecioando;
    }, [filters]);

    const mensagemErroItemSegmento = useCallback(() => {
        notifierStore.setNotifier({
            title: "Aviso!!!",
            content: <>
                <strong>Erro ao adicionar item no carrinho</strong><br />
                <span>Itens de segmentos diferentes não podem ser adicionados no mesmo carrinho</span>
            </>,
            noTimeOut: true
        });
        notifierStore.open();
    }, [])

    const mensagemErroItemCarrinho = useCallback((item: TCarrinhoItem | TCarrinhoAvulso, venda: boolean = false) => {
        const mensagem = venda 
            ? "Atualmente não é possível adicionar itens de lojas diferentes no mesmo pedido" 
            : "Atualmente não é possível adicionar geradores diferentes no mesmo pedido";
        confirmationDialog.setup({
            title:'Atenção!',
            content: (
                <Typography>{`${mensagem}. Deseja esvaziar o carrinho e adicionar este item?`}</Typography>
            ),
            onConfirmation: async () => {
                CarrinhoStore.limpar();
                if (vendaAvulso) {
                    await CarrinhoStore.addItemAvulso(item, true, estadoId);
                } else {
                    await CarrinhoStore.addItem(item, true);
                }
            },
            onClose: () => confirmationDialog.close(),
            onNegation: () => confirmationDialog.close(),
            yesText: 'Esvaziar Carrinho e Adicionar',
            noText: 'Cancelar',
            noVariant: "outlined",
            fullWidth: isMobile
        })
        confirmationDialog.open()
    }, [vendaAvulso, estadoId]);

    const itensCarrinho = useMemo(() => {
        return (carrinho?.venda === 'avulso' ? carrinho?.avulsos : carrinho?.itens) || [];
    }, [carrinho?.venda, carrinho?.avulsos, carrinho?.itens]);

    const carrinhoVazio = useMemo(() => {
        return (!carrinho || !itensCarrinho?.length);
    }, [carrinho, itensCarrinho]);  

    const limparOrders = useCallback((): void => {
        const _orders = {...orders}
        _orders.order_1 = !vendaAvulso ? "prioridade" : "created_at";
        _orders.order_2 = !vendaAvulso ? "created_at" : "";
        _orders.order_3 =  "";
        
        const _ordersState = Object.values(_orders).filter((item: string) => item !== "");
        ProdutosDataGridStore.setOrderBy([..._ordersState]);
        setOrders(_orders);
    }, [orders, vendaAvulso]);

    const limparFiltros = useCallback((limparUf:boolean = false): void => {
        const _filters = {...filters}
        const _fields = Object.keys(_filters);

        for (const _field of _fields) {
            if (_field !== 'segmento' && _field !== 'estado_id') {
                _filters[_field].value = null;
            } else if (limparUf && _field === 'estado_id' && estadoEstabelecimento?.value && carrinhoVazio) {
                _filters[_field].value = estadoEstabelecimento.value;
            }
        }

        setPotenciaInicial("");
        setPotenciaFinal("");
        limparOrders();

        ProdutosDataGridStore.setFilters(_filters);
    }, [filters, estadoEstabelecimento, carrinhoVazio]);

    const buscar = useCallback((estadoEstabelecimentoInicial?: EstadoEstabelecimento, estadoId?: string) => {
        if ((estadoEstabelecimento && estadoEstabelecimento.label) || estadoEstabelecimentoInicial) {
            
            const _filters: { [filterName: string]: Filter } = {...filters};
            if (estadoEstabelecimentoInicial) {
                setEstadoEstabelecimento(estadoEstabelecimentoInicial);
                if (!_filters[FIELDS.ESTADO_ID]) {
                    _filters[FIELDS.ESTADO_ID] = {field: 'estado_id', value: estadoEstabelecimentoInicial.value};
                } else {
                    _filters[FIELDS.ESTADO_ID].value = estadoEstabelecimentoInicial.value;
                }    
            }

            if (vendaAvulso) {
                _filters[`${FIELDS.INCLUDES}`] = { field: FIELDS.INCLUDES, value: "atributos,precos,mppt" }
                _filters[`${FIELDS.SEGMENTO}`] = { field: FIELDS.SEGMENTO, value: "" }
            } else if (!_filters[`${FIELDS.SEGMENTO}`]?.value && _segmento && SEGMENTOS?.includes(_segmento)) {
                _filters[`${FIELDS.SEGMENTO}`] = { field: FIELDS.SEGMENTO, value: _segmento }
            }

            if (estadoId && (estadoId !== _filters[FIELDS.ESTADO_ID]?.value)) {
                _filters[FIELDS.ESTADO_ID] = {field: 'estado_id', value: estadoId};
                setUpdatedUf(true);
            }

            /*if (_filters && _filters[`${FIELDS.POTENCIA_INICIAL}_inicial`].value && !_filters[`${FIELDS.POTENCIA_FINAL}_final`].value) {
                delete _filters[`${FIELDS.POTENCIA_INICIAL}_inicial`].criteria;
            } else {
                _filters[`${FIELDS.POTENCIA_INICIAL}_inicial`].criteria = SUFIXO_FIELD.MORE_EQUAL;
            }*/

            const _orders = Object.values(orders).filter((item: string) => item !== "");
            ProdutosDataGridStore.setOrderBy([..._orders]);
            ProdutosDataGridStore.setFilters({..._filters});
            ProdutosDataGridStore.list();
        }
    }, [potenciaInicial, potenciaFinal, filters, orders, vendaAvulso, _segmento]);

    const getDetalhes = useCallback(async (id: number): Promise<void> => {
        const response = await ProdutosDataGridStore.find({primaryKey: id, includes: ['itens', 'selos', 'selos.selo', 'itens.componente']});
        if (response.statusCode !== STATUS_CODE.OK) {
            notifierStore.setNotifier({
                title: "Aviso!!!",
                content: <>
                    <strong>Erro ao buscar detalhes do produto</strong><br />
                    <span>{response.message}</span>
                </>,
                onClose: () => {
                    notifierStore.setOpen(false);
                },
                timeOut: 2_500,
            })
            notifierStore.open();
            return
        }
        setProdutoDetalhes(response.data[0]);
    }, []);

    const validate = useCallback(()=>{
        const errorMessages: string[] = [];
        const errors = { ...INITIAL_ERROR_STATE };
        if (potenciaInicial && potenciaFinal){
            let _potenciaInicial = potenciaInicial;
            let _potenciaFinal = potenciaFinal;

            _potenciaInicial = _potenciaInicial.replace(/\./g, "");
            _potenciaFinal = _potenciaFinal.replace(/\./g, "");

            _potenciaInicial = _potenciaInicial.replace(",", ".");
            _potenciaFinal = _potenciaFinal.replace(",", ".");

            if (Number(_potenciaInicial) > Number(_potenciaFinal)) {
                errorMessages.push('A potência final não pode ser menor do que a potência inicial!')
                errors.potencia = { hasError: true, hintText: "" }
            }
        }
        if(errorMessages.length > 0){
            setErrorState(errors);
            notifierStore.setNotifier({
                title: "Aviso!",
                content: errorMessages,
                timeOut: 0,
                onClose: ()=>{
                    notifierStore.setOpen(false)
                }
            })
            notifierStore.setOpen(true)
            return false;
        }
        return true;
    },[potenciaInicial, potenciaFinal])

    useEffect(() => {
        if (estadoEstabelecimento?.label) {
            buscar(estadoEstabelecimento);
            setIsLoaded(true);
        }

    },[estadoEstabelecimento])

    useEffect(() => {
        if (estadoId) {
            getAvulsos(estadoId);
        }
    },[estadoId])

    const disabledUf = useMemo(() => {
        return carrinho?.venda === 'avulso' && !!carrinho?.avulsos?.length;
    }, [carrinho]);

    useEffect(() => {
        const itensNoCarrinho = (!!carrinho?.itens?.length || !!carrinho?.avulsos?.length);
        const atualizarUf = isLoaded && !updatedUf && estadoEstabelecimento && itensNoCarrinho && disabledUf;
        if (atualizarUf && filters[FIELDS.ESTADO_ID]?.value !== carrinho?.estado_id) {
            buscar(estadoEstabelecimento, carrinho?.estado_id);
        }
    },[estadoEstabelecimento, filters, carrinho, updatedUf, isLoaded, disabledUf]);

    useEffect(() => {
        (async () => {
            RequestUtil.loader({
                asyncRequest: [],
                syncRequest: [
                    getComponentes(),
                    getSelos(),
                    getEstruturas(),
                    uploadUrl(),
                    getAtributos(),
                    getUserInfo(),
                ],
                asyncResponses(_responses: any[]) {},
                syncResponses(_responses: any[]) {
                    let estado = ESTADOS.find(e => e.value === _responses[5].data[0].estado_id);
                    if (!estado?.label) {
                        notifierStore.setNotifier({
                            title: "Aviso!!!",
                            content: <>
                                <strong>Problema de cadastro de usuário</strong><br />
                                <span>usuário sem Estado (UF) cadastrada. Favor entrar em contato com o TI.</span>
                            </>,
                            onClose: () => {
                                setAvisoInicial('usuário sem Estado (UF) cadastrada. Favor entrar em contato com o TI.');
                            },
                            timeOut: 2_500,
                        })
                        notifierStore.open();
                    } else {
                        estadoId$.next(estado.value || "");
                        setEstadoEstabelecimento({label: estado?.label ? estado.label : '', value: estado?.value ? estado.value : ''});
                    }
                }
            })
        })();
    }, [])
    
    useEffect(() => {
        if (_segmento && filters && filters[`${FIELDS.SEGMENTO}`] && filters[`${FIELDS.SEGMENTO}`].value !== _segmento) {
            limparFiltros();
            const _filters: { [filterName: string]: Filter } = {...filters};
            if (filters && _filters[`${FIELDS.SEGMENTO}`] && SEGMENTOS?.includes(_segmento)) {
                _filters[`${FIELDS.SEGMENTO}`].value = _segmento
            }
            ProdutosDataGridStore.setFilters(_filters);
            ProdutosDataGridStore.setPage(1);
            buscar();
        }
    }, [_segmento])

    useEffect(() => {
        let _orders = ORDER_KITS;
        if (tipoVenda !== 'avulso') {
            ProdutosDataGridStore.setPaths(PATH_KITS);
        } else {
            _orders = ORDER_AVULSO;
            ProdutosDataGridStore.setPaths(PATH_AVULSO);
        }

        const _ordersState = Object.values(_orders).filter((item: string) => item !== "");
        ProdutosDataGridStore.setOrderBy([..._ordersState]);
        setOrders(_orders);

        setAlterouTipoVenda(!alterouTipoVenda);
    }, [tipoVenda, _segmento])

    useEffect(() => {
        limparFiltros();
        const _filters: { [filterName: string]: Filter } = {...FILTERS};
        if (SEGMENTOS?.includes(_segmento)) {
            _filters[`${FIELDS.SEGMENTO}`] = { field: FIELDS.SEGMENTO, value: _segmento }
            ProdutosDataGridStore.setFilters(_filters);
        }
        ProdutosDataGridStore.setPage(1);
        buscar();
    }, [alterouTipoVenda])

    const loadComponentes = async()=>{
        const response: IDataResponse = await apiNoLoading.get({
            url: `/estoque/componentes/listar?includes=atributos&segmento=${_segmento}&estado_id=${estadoId}`,
        });

        if (response.statusCode === STATUS_CODE.OK) {
            const data = response.data?.rows || response.data;
            setComponentesState(data);
        }
    }

    const loadEstruturas = async()=>{
        const response: IDataResponse = await apiNoLoading.get({
            url: `/estruturas/listar?segmento=${_segmento}&estado_id=${estadoId}`,
        });

        if (response.statusCode === STATUS_CODE.OK) {
            const data = response.data?.rows || response.data;
            setEstruturasState(data);
        }
    }
    useEffect(()=>{
        loadComponentes();
        loadEstruturas();
    },[_segmento, estadoId])
    
    useEffect(()=>{
        if(componentesState?.length){
            //seta os modulos
            const modulos = componentesState.filter((item: ComponenteType)=>item.categoria_componentes_id === MODULO_ID && item.exibir_listagem && ["todos", `${_segmento}`].includes(item.segmento))?.map((i:ComponenteType)=>{
                return {
                    text: i.modelo,
                    value: i.id,
                }
            })
            setListaModulos(modulos)

            //seta componentes conforme segmento
            if(_segmento === 'on'){
                //inversores
                const inversoresOn: SelectOption[] = componentesState.filter((item: ComponenteType)=> [INVERSOR_ID, MICROINVERSOR_ID].includes(item.categoria_componentes_id) && item.exibir_listagem && ["todos", `${_segmento}`].includes(item.segmento)).map((i: ComponenteType)=>{
                    return {
                        text: i.modelo,
                        value: i.id.toString()
                    }
                })
                setListaInversores(inversoresOn);
            }else if(_segmento === 'off'){
                //inversores
                const inversoresOff: SelectOption[] = componentesState.filter((item: ComponenteType)=> [ONDA_MODIFICADA_ID, ONDA_SENOIDAL_ID, DRIVE_SOLAR_ID].includes(item.categoria_componentes_id) && item.exibir_listagem && ["todos", `${_segmento}`].includes(item.segmento)).map((i: ComponenteType)=>{
                    return {
                        text: i.modelo,
                        value: i.id.toString()
                    }
                })
                setListaInversores(inversoresOff);
                //controladores de carga
                const controladores: SelectOption[] = componentesState.filter((item: ComponenteType)=> [CONTROLADORES_DE_CARGA_ID].includes(item.categoria_componentes_id) && item.exibir_listagem && ["todos", `${_segmento}`].includes(item.segmento)).map((i: ComponenteType)=>{
                    return {
                        text: i.modelo,
                        value: i.id.toString()
                    }
                })
                setListaControladorCarga(controladores);
            }
        }
        if(estruturasState?.length){
            //estruturas
            const estruturas: SelectOption[] = estruturasState.map((item: TiposEstruturas)=>{
                return {
                    text: item.nome,
                    value: item.id.toString(),
                }
            })
            setListEstruturas(estruturas);
        }
    },[componentesState, estruturasState])

    const renderProduto = useCallback((item: TProduto) => {
        return (
            <Produto 
                estruturas={estruturasState}
                data={item} 
                classes={classes} 
                onDetalhesClick={async (produto) => {
                    if (produto.id) {
                        await getDetalhes(produto.id);
                    }
                }} 
                onAdd={async (_produto) => {
                    const carrinho = CarrinhoStore.getCarrinho();
                    const item = carrinho?.itens?.find(i => i?.produto?.id === _produto?.id);
                    if (validateTipoVenda()) {
                        mensagemErroItemCarrinho(_produto, true)
                        return;
                    }
                    if (!item && !vendaAvulso && _totalItens > 0) {
                        mensagemErroItemCarrinho(_produto)
                        return;
                    }
                    if (validateSegmento(_produto)) {
                        mensagemErroItemSegmento()
                        return;
                    }
                    await CarrinhoStore.addItem(_produto, true);
                }}
                adicaoDesabilitada={false}
                nomeMinHeight={nomeMinHeight}
                onNomeMinHeightChange={() => {
                    let minHeight = 0;
                    ProdutosDataGridStore.getRows().forEach(r => {
                        if (minHeight < r.heightNome) {
                            minHeight = r.heightNome;
                        }
                    });
                    setNomeMinHeight(minHeight);
                }}
                tagsMinHeight={tagsMinHeight}
                onTagsMinHeightChange={() => {
                    let minHeight = 0;
                    ProdutosDataGridStore.getRows().forEach(r => {
                        if (minHeight < r.heightTags) {
                            minHeight = r.heightTags;
                        }
                    });
                    setTagsMinHeight(minHeight);
                }}
            />
        );
    }, [_totalItens, classes, estruturasState, getDetalhes, mensagemErroItemCarrinho, mensagemErroItemSegmento, nomeMinHeight, tagsMinHeight, vendaAvulso]);

    const renderAvulso = useCallback((avulso: ComponenteType) => {
        return (
            <Avulso 
                data={avulso} 
                classes={classes} 
                onDetalhesClick={async (_avulso) => {
                    if (_avulso.id) {
                        // await getDetalhes(produto.id);
                        setAvulsoDetalhes(_avulso);
                    }
                }} 
                onAdd={(_avulso) => {
                    if (validateTipoVenda()) {
                        mensagemErroItemCarrinho(_avulso, true)
                        return;
                    }
                    if (validateSegmento(_avulso)) {
                        mensagemErroItemSegmento()
                        return;
                    }
                    CarrinhoStore.addItemAvulso(_avulso, true, estadoId);
                }}
                adicaoDesabilitada={false}
                nomeMinHeight={nomeMinHeight}
                onNomeMinHeightChange={() => {
                    let minHeight = 0;
                    ProdutosDataGridStore.getRows().forEach(r => {
                        if (minHeight < r.heightNome) {
                            minHeight = r.heightNome;
                        }
                    });
                    setNomeMinHeight(minHeight);
                }}
                tagsMinHeight={tagsMinHeight}
                onTagsMinHeightChange={() => {
                    let minHeight = 0;
                    ProdutosDataGridStore.getRows().forEach(r => {
                        if (minHeight < r.heightTags) {
                            minHeight = r.heightTags;
                        }
                    });
                    setTagsMinHeight(minHeight);
                }}
            />
        );
    }, [_totalItens, classes, getDetalhes, mensagemErroItemCarrinho, mensagemErroItemSegmento, nomeMinHeight, tagsMinHeight, vendaAvulso]);

    const listaCategorias = useMemo(() => {
        let lista = (categorias?.data || [])
            .slice()
            .sort((a: TCategoriasComponentes, b: TCategoriasComponentes) => a.id - b.id);

        if (avulsos && avulsos?.data?.length) {
            const categoriasAvulso = avulsos?.data?.map((i:ComponenteType) => i?.categoria_componentes_id);
            lista = lista?.filter((i: TCategoriasComponentes) => categoriasAvulso?.includes(i?.id))
        } else {
            return []
        }

        const gruposMap = new Map<string, TCategoriasComponentes[]>();

        for (const item of lista) {
            const grupo = item.grupo ?? "";
            if (!gruposMap.has(grupo)) {
                gruposMap.set(grupo, []);
            }
            gruposMap.get(grupo)!.push(item);
        }

        const gruposProcessados = new Set<string>();
        const resultado: TCategoriasComponentes[] = [];

        for (const item of lista) {
            const grupo = item.grupo ?? "";
            if (!gruposProcessados.has(grupo)) {
                gruposProcessados.add(grupo);
                resultado.push(...(gruposMap.get(grupo) || []));
            }
        }

        return resultado.map(categoria => ({
            text: categoria.nome,
            value: categoria.id,
        }));
    }, [categorias, avulsos]);

    if (!isLoaded) {
        return <>{avisoInicial}</>
    }

    if (permissoes$?.value?.length > 0 && !PermissionUtil.can(PermissionUtil.PERMISSION_LOJA_ONGRID, permissoes$.value) && !PermissionUtil.can(PermissionUtil.PERMISSION_LOJA_OFFGRID, permissoes$.value) && !vendaAvulso) {
        return <>Usuário sem permissão de produtos ongrid e offgrid</>
    }

    if (permissoes$?.value?.length > 0 && !PermissionUtil.can(PermissionUtil.PERMISSION_LOJA_AVULSO, permissoes$.value) && vendaAvulso) {
        return <>Usuário sem permissão de produtos avulso</>
    }

    return (
        <div className="Home" style={isMobile ? { marginTop: "28px" } : {}}>
            <div className="row">
                <div className="X12">
                    <EasyDataGrid
                        paginationClasses={isMobile ? { toolbar: classes.paginationToolbarRoot, root: classes.paginationRoot } : {}}
                        store={ProdutosDataGridStore}
                        rowsRender={(rows: Cidade[]) => {
                            return <>
                                <GridPresenter
                                    className={isMobile ? "CardsContainerMobile" : "CardsContainer"}
                                    items={rows}
                                    itemRender={(item: any) => {
                                        if (vendaAvulso) return renderAvulso(item); 
                                        return renderProduto(item);
                                    }}
                                />
                            </>
                        }}
                        renderFilter={() => {
                            return (
                                <Filters
                                    actions={[
                                        <Fab size="small" color="default" aria-label="edit" onClick={() => {
                                            setOpenFilterDrawer(!openFilterDrawer);
                                        }}>
                                            <FilterList color={"secondary"} />
                                        </Fab>,
                                    ]}
                                >
                                    {!isMobile && <Grid
                                        container
                                        spacing={1}
                                        direction="row"
                                        alignItems="stretch"
                                        sx={{ width: "100%" }}
                                    >
                                        { vendaAvulso ? (
                                            <Grid size="grow">
                                                <InputComboBoxList
                                                    multiple
                                                    label="Categoria"
                                                    valueField="value"
                                                    textField="text"
                                                    value={listaCategorias?.filter((item: any) => filters && filters[FIELDS.CATEGORIA_COMPONENTES_ID]?.value?.includes(item?.value)) || []}
                                                    options={listaCategorias || []}
                                                    renderOptions={(_option) => {
                                                        return <>{filters[FIELDS.CATEGORIA_COMPONENTES_ID]?.value?.includes(_option?.value) ? <CheckBox color="primary" />: <CheckBoxOutlineBlank />} {_option?.text}</>
                                                    }}
                                                    onChange={(_categorias) => {
                                                        const _filters = {...filters};
                                                        _filters[FIELDS.CATEGORIA_COMPONENTES_ID].value = _categorias?.map((_modulo: any) => _modulo.value) || null;
                                                        ProdutosDataGridStore.setFilters(_filters);
                                                        ProdutosDataGridStore.setPage(1);
                                                        buscar();
                                                    }}
                                                />
                                            </Grid>
                                        ) : (
                                            <>
                                                <Grid size="grow">
                                                    <InputComboBoxList
                                                        multiple
                                                        label="Modelo do módulo"
                                                        chipColor="secondary"
                                                        valueField="value"
                                                        textField="text"
                                                        value={listaModulos?.filter((item: any) => filters && filters[FIELDS.MODULO_ID]?.value?.includes(item?.value)) || []}
                                                        options={listaModulos || []}
                                                        renderOptions={(_option) => {
                                                            return <>{filters[FIELDS.MODULO_ID]?.value?.includes(_option?.value) ? <CheckBox color="primary" />: <CheckBoxOutlineBlank />} {_option?.text}</>
                                                        }}
                                                        onChange={(_modulos) => {
                                                            const _filters = {...filters}
                                                            _filters[FIELDS.MODULO_ID].value = _modulos?.map((_modulo: any) => _modulo.value) || null
                                                            ProdutosDataGridStore.setFilters(_filters)
                                                            buscar();
                                                        }}

                                                    />
                                                </Grid>
                                                <Grid size="grow">
                                                <InputComboBoxList
                                                    multiple
                                                    chipColor="secondary"
                                                    label="Tipo de estrutura"
                                                    valueField="value"
                                                    textField="text"
                                                    value={listEstruturas?.filter((item: any) => filters && filters[FIELDS.ESTRUTURA_ID]?.value?.includes(item?.value)) || null}
                                                    options={listEstruturas || []}
                                                    renderOptions={(_option) => {
                                                        return <>{filters[FIELDS.ESTRUTURA_ID]?.value?.includes(_option?.value) ? <CheckBox color="primary" />: <CheckBoxOutlineBlank />} {_option?.text}</>
                                                    }}
                                                    onChange={(_estruturas) => {
                                                        const _filters = {...filters}
                                                        if (_estruturas && _estruturas?.length > 0) {
                                                            _filters[FIELDS.ESTRUTURA_ID].value = _estruturas?.map((_estrutura: any) => _estrutura.value) || null
                                                        } else {
                                                            _filters[FIELDS.ESTRUTURA_ID].value = null
                                                        }
                                                        ProdutosDataGridStore.setFilters(_filters);
                                                        buscar();
                                                    }}

                                                />
                                                </Grid>
                                            </> 
                                        )}

                                        <Grid size="grow">
                                            <Tooltip title={ disabledUf ? "Para alterar o estado de entrega, remova os itens do carrinho" : "" }>
                                                <Box>
                                                    <InputComboBoxList
                                                        label="Estado de entrega"
                                                        valueField="value"
                                                        textField="label"
                                                        value={ESTADOS?.find((item: any) => filters && item?.value === filters[FIELDS.ESTADO_ID]?.value) || estadoEstabelecimento}
                                                        options={ESTADOS || []}
                                                        disableClearable={true}
                                                        disabled={disabledUf}
                                                        onChange={(_estado) => {
                                                            const _filters = {...filters}
                                                            estadoId$.next(_estado?.value || "");
                                                            _filters[FIELDS.ESTADO_ID].value = _estado?.value || null
                                                            ProdutosDataGridStore.setFilters(_filters)
                                                            //reseta a paginacao em caso de mudanca de estado
                                                            if(ProdutosDataGridStore.getPage() > 1){
                                                                ProdutosDataGridStore.setPage(1)
                                                            }
                                                            limparFiltros();
                                                            buscar();
                                                        }}
                                                    />
                                                </Box>
                                            </Tooltip>
                                        </Grid>
                                    </Grid>}
                                </Filters>
                            )
                        }}
                    />
                </div>
            </div>

            <Carrinho store={CarrinhoStore} />

            <FilterDrawer
                open={openFilterDrawer}
                onOpen={() => {
                }}
                onClose={() => {
                    setOpenFilterDrawer(!openFilterDrawer)
                }}
                onSearch={() => {

                }}
            >
                <Box style={{ minWidth: "400px" }}>
                    <Box>
                        <Typography variant="body1" color="primary">Ordenar por</Typography>
                    </Box>
                    <Box>
                        <InputComboBoxList
                            simpleTooltip
                            label=""
                            valueField="value"
                            textField="label"
                            value={(vendaAvulso ? ORDENATION_AVULSO_OPTIONS : ORDENATION_OPTIONS)?.find((item: any) => orders.order_3 === item.value) || null}
                            options={(vendaAvulso ? ORDENATION_AVULSO_OPTIONS : ORDENATION_OPTIONS) || []}
                            renderOptions={(_option) => {
                                const SELOS = ['DESTAQUE', 'LANCAMENTO', 'PROMOCIONAL', 'TREINAMENTO', 'SHOWROOM',]
                                if (!vendaAvulso && SELOS.includes(_option.value)) {
                                    return <><Selo label={_option?.value} /> {_option?.label}</>
                                }
                                return <>{_option?.label}</>  
                            }}
                            onChange={(_orderOption) => {
                                const _orders = {...orders}
                                if (!_orderOption?.value) {
                                    _orders.order_1 = !vendaAvulso ? "prioridade" : "created_at";
                                    _orders.order_2 = !vendaAvulso ? "created_at" : "";
                                } else {
                                    _orders.order_1 = "";
                                    _orders.order_2 = "";
                                }
                                _orders.order_3 = _orderOption?.value || ""
                                
                                const _ordersState = Object.values(_orders).filter((item: string) => item !== "");
                                ProdutosDataGridStore.setOrderBy([..._ordersState]);
                                setOrders(_orders);
                            }}
                        />
                    </Box>
                 
                    {/* NÃO UTILIZADO NO MOMENTO 
                    <Box>
                        <InputComboBoxList
                            label=""
                            valueField="value"
                            textField="label"
                            value={CATEGORIAS?.find((item: any) => orders.order_2 === item.value) || null}
                            options={CATEGORIAS.filter((_categoria) => _categoria?.segmento === 'todos' || _categoria.segmento === _segmento) || []}
                            onChange={(_categoria) => {
                                const _orders = {...orders}
                                _orders.order_2 = _categoria?.value || ""
                                setOrders(_orders);
                                const _ordersState = Object.values(_orders).filter((item: string) => item !== "");
                                ProdutosDataGridStore.setOrderBy(_ordersState);
                            }}
                        />
                    </Box> */}
                    <Box>
                        <Typography variant="body1" color="primary">Filtrar por</Typography>
                    </Box>
                    {vendaAvulso && (
                        <>
                            <InputText
                                fullWidth
                                label="Busca por nome"
                                value={filters?.[`${FIELDS.NOME}`]?.value || ""}
                                onChange={(e: any) => {
                                    const _filters = {...filters};
                                    const _value = e.target.value || "";
                                    _filters[FIELDS.NOME].value = _value;
                                    ProdutosDataGridStore.setFilters(_filters);
                                }}
                            />
                            <InputComboBoxList
                                multiple
                                label="Categoria"
                                valueField="value"
                                textField="text"
                                value={listaCategorias?.filter((item: any) => filters && filters[FIELDS.CATEGORIA_COMPONENTES_ID]?.value?.includes(item?.value)) || []}
                                options={listaCategorias || []}
                                renderOptions={(_option) => {
                                    return <>{filters[FIELDS.CATEGORIA_COMPONENTES_ID]?.value?.includes(_option?.value) ? <CheckBox color="primary" />: <CheckBoxOutlineBlank />} {_option?.text}</>
                                }}
                                onChange={(_categorias) => {
                                    const _filters = {...filters};
                                    _filters[FIELDS.CATEGORIA_COMPONENTES_ID].value = _categorias?.map((_modulo: any) => _modulo.value) || null;
                                    ProdutosDataGridStore.setPage(1);
                                    ProdutosDataGridStore.setFilters(_filters);
                                }}
                            />
                        </>
                    )}
                    <Box>
                        <Tooltip title={ disabledUf ? "Para alterar o estado de entrega, remova os itens do carrinho" : "" }>
                            <Box>
                                <InputComboBoxList
                                    label="Estado de entrega"
                                    valueField="value"
                                    textField="label"
                                    value={ESTADOS?.find((item: any) => filters && item?.value === filters[FIELDS.ESTADO_ID]?.value) || null}
                                    options={ESTADOS || []}
                                    disableClearable={true}
                                    disabled={disabledUf}
                                    onChange={(_estado) => {
                                        const _filters = {...filters}
                                        _filters[FIELDS.ESTADO_ID].value = _estado?.value || null
                                        ProdutosDataGridStore.setFilters(_filters)
                                        
                                        //reseta a paginacao em caso de mudanca de estado
                                        if(ProdutosDataGridStore.getPage() > 1){
                                            ProdutosDataGridStore.setPage(1)
                                        }
                                    }}
                                />
                            </Box>
                        </Tooltip>
                    </Box>

                    {(_segmento && _segmento === "on" && !vendaAvulso) && <><Box>
                        <InputComboBoxList
                            multiple
                            chipColor="secondary"
                            label="Tipo de inversor"
                            valueField="value"
                            textField="label"
                            value={TIPO_INVERSOR?.filter((item: any) => filters && filters[FIELDS.TIPO_INVERSOR]?.value?.includes(item?.value)) || null}
                            options={TIPO_INVERSOR || []}
                            renderOptions={(_option) => {
                                return <>{filters[FIELDS.TIPO_INVERSOR]?.value?.includes(_option?.value) ? <CheckBox color="primary" />: <CheckBoxOutlineBlank />} {_option?.label}</>
                            }}
                            onChange={(_tipoInversores) => {
                                const _filters = {...filters}
                                _filters[FIELDS.TIPO_INVERSOR].value = _tipoInversores?.map((_tipoInversor: any) => _tipoInversor?.value) || null
                                ProdutosDataGridStore.setFilters(_filters)
                            }}
                        />
                    </Box>
                    <Box>
                        <InputComboBoxList
                            multiple
                            chipColor="secondary"
                            label="Modelo de inversor"
                            valueField="value"
                            textField="text"
                            value={listaInversores?.filter((item: any) => filters && filters[FIELDS.INVERSOR_ID]?.value?.includes(item?.value)) || null}
                            options={listaInversores || []}
                            renderOptions={(_option) => {
                                return <>{filters[FIELDS.INVERSOR_ID]?.value?.includes(_option?.value) ? <CheckBox color="primary" />: <CheckBoxOutlineBlank />} {_option?.text}</>
                            }}
                            onChange={(_inversores) => {
                                const _filters = {...filters}
                                _filters[FIELDS.INVERSOR_ID].value = _inversores?.map((_inversor: any) => _inversor.value) || null
                                ProdutosDataGridStore.setFilters(_filters)
                            }}

                        />
                    </Box>
                    <Box>
                        <InputComboBoxList
                            multiple
                            chipColor="secondary"
                            label="Nº de fases do inversor"
                            valueField="value"
                            textField="label"
                            value={NUMERO_FASES_INVERSOR?.filter((item: any) => filters && filters[FIELDS.NUMERO_FASES_INVERSOR]?.value?.includes(item?.value)) || null}
                            options={NUMERO_FASES_INVERSOR || []}
                            renderOptions={(_option) => {
                                return <>{filters[FIELDS.NUMERO_FASES_INVERSOR]?.value?.includes(_option?.value) ? <CheckBox color="primary" />: <CheckBoxOutlineBlank />} {_option?.label}</>
                            }}
                            onChange={(_numeroFases) => {
                                const _filters = {...filters}
                                if (_numeroFases && _numeroFases?.length > 0) {
                                    _filters[FIELDS.NUMERO_FASES_INVERSOR].value = _numeroFases?.map((_numeroFase: any) => _numeroFase.value) || null
                                } else {
                                    _filters[FIELDS.NUMERO_FASES_INVERSOR].value = null
                                }

                                ProdutosDataGridStore.setFilters(_filters)
                            }}
                        />
                    </Box>
                    <Box>
                        <InputComboBoxList
                            multiple
                            chipColor="secondary"
                            label="Tensão do inversor"
                            valueField="value"
                            textField="label"
                            value={TENSAO_INVERSOR?.filter((item: any) => filters && filters[FIELDS.TENSAO_INVERSOR]?.value?.includes(item?.value)) || null}
                            options={TENSAO_INVERSOR || []}
                            renderOptions={(_option) => {
                                return <>{filters[FIELDS.TENSAO_INVERSOR]?.value?.includes(_option?.value) ? <CheckBox color="primary" />: <CheckBoxOutlineBlank />} {_option?.label}</>
                            }}
                            onChange={(_tensoesInversor) => {
                                const _filters = {...filters}
                                if (_tensoesInversor && _tensoesInversor?.length > 0) {
                                    _filters[FIELDS.TENSAO_INVERSOR].value = _tensoesInversor?.map((_tensaoInversor: any) => _tensaoInversor.value) || null
                                } else {
                                    _filters[FIELDS.TENSAO_INVERSOR].value = null
                                }

                                ProdutosDataGridStore.setFilters(_filters)
                            }}
                        />
                    </Box></>}

                    {!vendaAvulso && (<Box>
                        <InputComboBoxList
                            multiple
                            chipColor="secondary"
                            label="Modelo do módulo"
                            valueField="value"
                            textField="text"
                            value={listaModulos?.filter((item: any) => filters && filters[FIELDS.MODULO_ID]?.value?.includes(item?.value)) || null}
                            options={listaModulos || []}
                            renderOptions={(_option) => {
                                return <>{filters[FIELDS.MODULO_ID]?.value?.includes(_option?.value) ? <CheckBox color="primary" />: <CheckBoxOutlineBlank />} {_option?.text}</>
                            }}
                            onChange={(_modulos) => {
                                const _filters = {...filters}
                                _filters[FIELDS.MODULO_ID].value = _modulos?.map((_modulo: any) => _modulo.value) || null
                                ProdutosDataGridStore.setFilters(_filters)
                            }}

                        />
                    </Box>)}
                    {/* OFF */}
                    
                    {(_segmento && _segmento === "off" && !vendaAvulso) && <>
                    {/* Técnologia do controlador de carga */}
                        <Box>
                            <InputComboBoxList
                                multiple
                                chipColor="secondary"
                                label="Técnologia do controlador de carga"
                                valueField="value"
                                textField="label"
                                value={TECNOLOGIA_CONTROLADOR_CARGA?.filter((item: any) => filters && filters[FIELDS.TECNOLOGIA_CONTROLADOR_CARGA]?.value?.includes(item?.value)) || null}
                                options={TECNOLOGIA_CONTROLADOR_CARGA || []}
                                renderOptions={(_option) => {
                                    return <>{filters[FIELDS.TECNOLOGIA_CONTROLADOR_CARGA]?.value?.includes(_option?.value) ? <CheckBox color="primary" /> : <CheckBoxOutlineBlank />} {_option?.label}</>
                                }}
                                onChange={(_tecnologiasControladorCarga) => {
                                    const _filters = { ...filters }
                                    _filters[FIELDS.TECNOLOGIA_CONTROLADOR_CARGA].value = _tecnologiasControladorCarga?.map((_tecnologiaControladorCarga: any) => _tecnologiaControladorCarga.value) || null
                                    ProdutosDataGridStore.setFilters(_filters)
                                }}
                            />
                        </Box>
                        {/* Controlador de carga */}
                        <Box>
                            <InputComboBoxList 
                                multiple
                                chipColor="secondary"
                                label="Controlador de carga"
                                valueField="value"
                                textField="text"
                                value={listaControladorCarga?.filter((item: any) => filters && filters[FIELDS.CONTROLADOR_ID]?.value?.includes(item?.value)) || null}
                                options={listaControladorCarga || []}
                                renderOptions={(_option) => {
                                    return <>{filters[FIELDS.CONTROLADOR_ID]?.value?.includes(_option?.value) ? <CheckBox color="primary" />: <CheckBoxOutlineBlank />} {_option?.text}</>
                                }}
                                onChange={(_controladores) => {
                                    const _filters = {...filters}
                                    _filters[FIELDS.CONTROLADOR_ID].value = _controladores?.map((_controlador: any) => _controlador.value) || null
                                    ProdutosDataGridStore.setFilters(_filters)
                                }}

                                />
                        </Box>
                        {/* Tipo do inversor */}
                        <Box>
                            <InputComboBoxList
                                multiple
                                chipColor="secondary"
                                label="Tipo de inversor"
                                valueField="value"
                                textField="label"
                                value={TIPO_INVERSOR_OFFGRID?.filter((item: any) => filters && filters[FIELDS.TIPO_INVERSOR_OFF]?.value?.includes(item?.value)) || null}
                                options={TIPO_INVERSOR_OFFGRID || []}
                                renderOptions={(_option) => {
                                    return <>{filters[FIELDS.TIPO_INVERSOR_OFF]?.value?.includes(_option?.value) ? <CheckBox color="primary" />: <CheckBoxOutlineBlank />} {_option?.label}</>
                                }}
                                onChange={(_tipoInversores) => {
                                    const _filters = {...filters}
                                    _filters[FIELDS.TIPO_INVERSOR_OFF].value = _tipoInversores?.map((_tipoInversor: any) => _tipoInversor?.value) || null
                                    ProdutosDataGridStore.setFilters(_filters)
                                }}
                            />
                        </Box>
                        {/* Tipo de bateria */}
                        <InputComboBoxList
                                multiple
                                chipColor="secondary"
                                label="Tipo de bateria"
                                valueField="value"
                                textField="label"
                                value={TIPO_BATERIA?.filter((item: any) => filters && filters[FIELDS.TIPO_BATERIA]?.value?.includes(item?.value)) || null}
                                options={TIPO_BATERIA || []}
                                renderOptions={(_option) => {
                                    return <>{filters[FIELDS.TIPO_BATERIA]?.value?.includes(_option?.value) ? <CheckBox color="primary" /> : <CheckBoxOutlineBlank />} {_option?.label}</>
                                }}
                                onChange={(_tiposBateria) => {
                                    const _filters = { ...filters }
                                    _filters[FIELDS.TIPO_BATERIA].value = _tiposBateria?.map((_tipoBateria: any) => _tipoBateria.value) || null
                                    ProdutosDataGridStore.setFilters(_filters)
                                }}
                            />
                        {/* Tensão da bateria */}
                        <Box>
                            <InputComboBoxList
                                multiple
                                chipColor="secondary"
                                label="Tensão da bateria"
                                valueField="value"
                                textField="label"
                                value={TENSAO_BATERIA?.filter((item: any) => filters && filters[FIELDS.TENSAO_BATERIA]?.value?.includes(item?.value)) || null}
                                options={TENSAO_BATERIA || []}
                                renderOptions={(_option) => {
                                    return <>{filters[FIELDS.TENSAO_BATERIA]?.value?.includes(_option?.value) ? <CheckBox color="primary" /> : <CheckBoxOutlineBlank />} {_option?.label}</>
                                }}
                                onChange={(_tensoesBateria) => {
                                    const _filters = { ...filters }
                                    _filters[FIELDS.TENSAO_BATERIA].value = _tensoesBateria?.map((_tensaoBateria: any) => _tensaoBateria.value) || null
                                    ProdutosDataGridStore.setFilters(_filters)
                                }}
                            />
                        </Box>
                    </>}

                    {!vendaAvulso && (<Box>
                        <InputComboBoxList
                            multiple
                            chipColor="secondary"
                            label="Tipo de estrutura"
                            valueField="value"
                            textField="text"
                            value={listEstruturas?.filter((item: any) => filters && filters[FIELDS.ESTRUTURA_ID]?.value?.includes(item?.value)) || null}
                            options={listEstruturas || []}
                            renderOptions={(_option) => {
                                return <>{filters[FIELDS.ESTRUTURA_ID]?.value?.includes(_option?.value) ? <CheckBox color="primary" />: <CheckBoxOutlineBlank />} {_option?.text}</>
                            }}
                            onChange={(_estruturas) => {
                                const _filters = {...filters}
                                if (_estruturas && _estruturas?.length > 0) {
                                    _filters[FIELDS.ESTRUTURA_ID].value = _estruturas?.map((_estrutura: any) => _estrutura.value) || null
                                } else {
                                    _filters[FIELDS.ESTRUTURA_ID].value = null
                                }

                                ProdutosDataGridStore.setFilters(_filters)
                                // buscar();
                            }}

                        />
                    </Box>)}
                    
                    {(_segmento && _segmento === "on"  && !vendaAvulso) && <><Box>
                        <InputText
                            fullWidth
                            label="Potência inicial"
                            value={potenciaInicial}
                            error={errorState.potencia.hasError}
                            maxLength={8}
                            InputProps={{
                                autocomplete: 'off',
                            }}
                            onChange={(e: any) => {
                                const _value = maskDecimal(e.target.value);
                                //const _value = e.target.value.replace(/[^0-9]/g, '');
                                const _filters = {...filters}
                                _filters[`${FIELDS.POTENCIA_INICIAL}_inicial`].value = _value
                                ProdutosDataGridStore.setFilters(_filters)
                                setPotenciaInicial(_value)
                            }}
                            sufix={<>kWp</>}
                        />
                    </Box>
                    <Box>
                        <InputText
                            fullWidth
                            label="Potência final"
                            value={potenciaFinal}
                            error={errorState.potencia.hasError}
                            maxLength={8}
                            InputProps={{
                                autocomplete: 'off',
                            }}
                            onChange={(e: any) => {
                                const _value = maskDecimal(e.target.value);
                                //const _value = e.target.value.replace(/[^0-9]/g, '');
                                const _filters = {...filters}
                                _filters[`${FIELDS.POTENCIA_FINAL}_final`].value = _value
                                ProdutosDataGridStore.setFilters(_filters)
                                setPotenciaFinal(_value)
                            }}
                            sufix={<>kWp</>}
                        />
                    </Box>
                    </>}

                    <Box className={classes.acoes_filtro}>
                        <Button 
                            className={classes.acoes_button}
                            variant="outlined" 
                            color="secondary"
                            onClick={() => {
                                setErrorState(INITIAL_ERROR_STATE);
                                limparFiltros(true);    
                            }}
                        >
                            Limpar Filtros
                        </Button>
                        <Button 
                            className={classes.acoes_button}
                            variant="contained" 
                            color="primary" 
                            onClick={() => {
                                if (!validate()) {
                                    return;
                                }else{
                                    setErrorState(INITIAL_ERROR_STATE);
                                }
                                buscar();
                                setOpenFilterDrawer(false);
                            }}
                        >
                            Buscar
                        </Button>
                    </Box>
                </Box>
            </FilterDrawer>

            {(produtoDetalhes && !vendaAvulso) && <DetalhesProduto 
                componentes = {componentesState}
                estruturas = {estruturasState}
                produto={produtoDetalhes} 
                open={produtoDetalhes !== null} 
                adicaoDesabilitada={false}
                onClose={() => setProdutoDetalhes(null)} 
                onAdd={async (_produto) => {
                    const carrinho = CarrinhoStore.getCarrinho();
                    const item = carrinho?.itens?.find(i => i?.produto?.id === _produto?.id);
                    if (validateTipoVenda()) {
                        mensagemErroItemCarrinho(_produto, true)
                        return;
                    }
                    if (!item && !vendaAvulso && _totalItens > 0) {
                        mensagemErroItemCarrinho(_produto)
                        return;
                    }
                    if (validateSegmento(_produto)) {
                        mensagemErroItemSegmento()
                        return;
                    }
                    await CarrinhoStore.addItem(_produto, true);
                    setProdutoDetalhes(null)
                }}
            />}

            {(avulsoDetalhes && vendaAvulso) && <DetalhesAvulso 
                carrinho={CarrinhoStore.getCarrinho()} 
                componente={avulsoDetalhes} 
                open={avulsoDetalhes !== null} 
                adicaoDesabilitada={false}
                onClose={() => setAvulsoDetalhes(null)} 
                onAdd={async (_avulso) => {
                    const carrinho = CarrinhoStore.getCarrinho();
                    const item = carrinho?.itens?.find(i => i?.produto?.id === _avulso?.id);
                    if (validateTipoVenda()) {
                        mensagemErroItemCarrinho(_avulso, true)
                        return;
                    }
                    if (!item && !vendaAvulso && _totalItens > 0) {
                        mensagemErroItemCarrinho(_avulso)
                        return;
                    }
                    if (validateSegmento(_avulso)) {
                        mensagemErroItemSegmento()
                        return;
                    }
                    await CarrinhoStore.addItemAvulso(_avulso, true, estadoId);
                    setAvulsoDetalhes(null)
                }}
            />}

        </div>
    );
};

export { Home }